
export default function openModal(url,title,closeCallback){
    document.getElementById("modal-title").innerHTML = title;
    document.getElementById("modal-iframe").setAttribute('src', url);
    document.getElementById('modal-content').classList.add('loading');
    document.getElementById('modal-iframe').addEventListener('load',() =>{
            let iframe = document.getElementById('modal-iframe');
            iframe.style.height = iframe.contentWindow.document.body.scrollHeight +'px';
            document.getElementById('modal-content').classList.remove('loading');
        },
        { once: true }
    );
    import(/* webpackChunkName: "micromodal" */ 'micromodal').then(({default: MicroModal}) => {
        MicroModal.show('modal', {
            onClose:() =>
            {
                if (closeCallback) closeCallback();
                document.getElementById('modal-title').innerHTML = "";
                document.getElementById('modal-content').innerHTML = '<iframe id="modal-iframe" class="modal_iframe"></iframe>';
            }
        });
    });
}


